import CloseIcon from '@mui/icons-material/Close';
import {
  Modal,
  Box,
  Button,
  Typography,
  TextField,
  CircularProgress,
  IconButton,
} from '@mui/material';
import React, { useState, useEffect } from 'react';

import apiReq from 'core/api';

export default function BusinessInfoEditModal({ open, onClose, onSave, projectId }) {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null); // 'saved' | 'error' | null

  useEffect(() => {
    if (open && projectId) {
      setLoading(true);
      apiReq(`projects/business-requirements?project_id=${projectId}`, 'get')
        .then((res) => {
          setValue(res?.business_requirements || '');
        })
        .finally(() => setLoading(false));
    }
  }, [open, projectId]);

  const handleSave = () => {
    setSaving(true);
    apiReq(`projects/business-requirements?project_id=${projectId}`, 'post', {
      business_requirements: value,
    })
      .then(() => {
        setStatus('saved');
        if (onSave) onSave(value);
        setTimeout(() => setStatus(null), 2000);
        onClose();
      })
      .catch(() => {
        setStatus('error');
        setTimeout(() => setStatus(null), 2000);
      })
      .finally(() => setSaving(false));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" mb={2}>
          Редактировать вводную информацию
        </Typography>
        {loading ? (
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <TextField
            multiline
            minRows={5}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            fullWidth
            variant="outlined"
            placeholder="Введите текст..."
            sx={{ overflowY: 'auto', maxHeight: '300px' }}
            disabled={saving}
          />
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          sx={{ mt: 2 }}
          disabled={saving || loading}
        >
          {saving ? 'Сохраняю...' : 'Сохранить'}
        </Button>
        {status === 'saved' && (
          <Typography color="success.main" align="center" mt={1}>
            Сохранено
          </Typography>
        )}
        {status === 'error' && (
          <Typography color="error.main" align="center" mt={1}>
            Ошибка
          </Typography>
        )}
      </Box>
    </Modal>
  );
}
